import { Action, ActionType } from "./actionTypes";
import { School, Centre, Country, Product } from "app/shared/model";
import { EditPricelistResponse } from "app/shared/model/EditPricelist";
import { FormError } from "app/shared/model/Form";
import { PricingYearId } from "app/shared/model/PricingYearId";
import { SaveState } from "app/shared/ui/GenericSaveAndBackButton";
import {
  readStoredProductType,
  writeSelectedCentreCode,
} from "../domain/storage/localStorage";

export function pageLoaded(schools: School[], centres: Centre[], countries: Country[], products: Product[], pricingYears: PricingYearId[]) : Action {
    return {        
        type: ActionType.PageLaded,
        schools: schools,
        centres: centres,
        countries: countries,
        products: products,
        pricingYears: pricingYears,
        selectedProductType: readStoredProductType() ?? 'Accommodation',
        formState: SaveState.Standard,
        isLoading: false,
        formErrors: [],
        errorMessage: ''
    };
}

export function changeSelectedProductType(selectedProductType: string): Action {
    return {
        type: ActionType.ChangeSelectedProductType,
        selectedProductType: selectedProductType
    }
}

export function changeSelectedPricingYear(selectedPricingYear: number): Action {
    return {
        type: ActionType.ChangeSelectedPricingYear,
        selectedPricingYearId: selectedPricingYear
    }
}

export function changeSelectedCentre(selectedCentreCode: string): Action {
    writeSelectedCentreCode(selectedCentreCode);
    return {
        type: ActionType.ChangeSelectedCentre,
        selectedCentreCode
    };
}


export function loadPricelist(pricelist: EditPricelistResponse[]): Action
{   
    return {
        type: ActionType.LoadPricelist,
        pricelist: pricelist,
       // draftPricelist: pricelist,
    }
}

export function loadDraftPricelist(draftPricelist: EditPricelistResponse[]): Action
{
    return {
        type: ActionType.LoadDraftPricelist,
        draftPricelist: draftPricelist
    }
}

export function updateDraftPricelistItem(pricelistItem: EditPricelistResponse, pricelistIndex: number): Action
{
    return {
        type: ActionType.UpdateDraftPricelistItem,
        pricelistItem: pricelistItem,
        pricelistIndex: pricelistIndex
    }
}

export function setFormState(formState: SaveState, errorMessage: string = ''): Action
{
    return {
        type: ActionType.SetFormState,
        formState: formState,
        errorMessage: errorMessage,
    }
}

export function setIsLoading(isLoading: boolean): Action
{
    return {
        type: ActionType.SetIsLoading,
        isLoading: isLoading
    }
}

export function setFormErrors(formErrors: FormError[]): Action
{
    return {
        type: ActionType.SetFormErrors,
        formErrors: formErrors
    }
}

